/*
 * @Author: your name
 * @Date: 2021-02-19 10:28:50
 * @LastEditTime: 2021-02-19 10:54:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \show-m\src\plugins\oss.js
 */
import OSS from 'ali-oss';
import apis from '../common/apis'
import axios from './axios'

const ossPlugin = {}

ossPlugin.install = (Vue) => {
  Vue.mixin({
    methods: {
      async glGetOssClient() {
        try {
          if (this.$oss && !this.$oss.client) {
            const { data } = await axios.get(apis.common.oss) || {}
            const cfg = {
              endpoint: data.endpoint,
              accessKeyId: data.appKey,
              accessKeySecret: data.appSecret,
              bucket: data.bucketname
            }

            global.$goss = global.$goss || {};
            this.$oss.client = global.$goss.client = new OSS(cfg);
            this.$oss.baseDir = global.$goss.baseDir = data.basedir;
          }
        } catch (err) {
          this.$notify({
            title: '提示',
            message: (err && err.data && err.data.msg) || 'oss配置获取错误',
            type: 'error',
            duration: 3000,
          })
        }
      }
    },
  })
}

export default ossPlugin



// WEBPACK FOOTER //
// ./src/plugins/oss.js